import { render, staticRenderFns } from "./fpdk3.vue?vue&type=template&id=0dfc6e1c&scoped=true&"
import script from "./fpdk3.vue?vue&type=script&lang=js&"
export * from "./fpdk3.vue?vue&type=script&lang=js&"
import style0 from "./fpdk3.vue?vue&type=style&index=0&id=0dfc6e1c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfc6e1c",
  null
  
)

export default component.exports